import { render, staticRenderFns } from "./EntityFetchList.vue?vue&type=template&id=1c0d0855&scoped=true"
import script from "./EntityFetchList.vue?vue&type=script&lang=js"
export * from "./EntityFetchList.vue?vue&type=script&lang=js"
import style0 from "./EntityFetchList.vue?vue&type=style&index=0&id=1c0d0855&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0d0855",
  null
  
)

export default component.exports